<template>
    <div class="price-in-pharmacy" :class="classPriceInPharmacy">
        <div v-if="titleText && title" class="price-in-pharmacy__title">
            {{ titleText }}
        </div>
        <div v-else-if="title" class="price-in-pharmacy__title">
            {{ $t('productDetail.priceInPharmacy').toUpperCase() }}
        </div>
        <div class="price-in-pharmacy__content" :class="{ 'price-in-pharmacy__content--default': title }">
            <div class="price-in-pharmacy__new">
                <span class="notranslate" v-html="$formatCurrency(price)"></span>
                <span class="ico" @click="openModalPriceInPharmacy">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7 0.5C3.13111 0.5 0 3.63075 0 7.5C0 11.3688 3.13075 14.5 7 14.5C10.8689 14.5 14 11.3693 14 7.5C14 3.63116 10.8693 0.5 7 0.5ZM7 13.5233C3.67877 13.5233 0.976746 10.8213 0.976746 7.5C0.976746 4.17875 3.67877 1.47675 7 1.47675C10.3212 1.47675 13.0233 4.17875 13.0233 7.5C13.0233 10.8213 10.3212 13.5233 7 13.5233Z"
                            fill="white"
                        />
                        <path
                            d="M6.99977 6.33508C6.58513 6.33508 6.29028 6.51019 6.29028 6.76818V10.2787C6.29028 10.4999 6.58513 10.721 6.99977 10.721C7.39598 10.721 7.71845 10.4999 7.71845 10.2787V6.76813C7.71845 6.51016 7.39598 6.33508 6.99977 6.33508Z"
                            fill="white"
                        />
                        <path
                            d="M7.00016 4.1698C6.57631 4.1698 6.24463 4.47386 6.24463 4.824C6.24463 5.17416 6.57634 5.48744 7.00016 5.48744C7.41481 5.48744 7.74654 5.17416 7.74654 4.824C7.74654 4.47386 7.41478 4.1698 7.00016 4.1698Z"
                            fill="white"
                        />
                    </svg>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    priceBefore: {
        type: Number,
        required: false,
        default: 0,
    },
    price: {
        type: Number,
        required: true,
    },
    title: {
        type: Boolean,
        default: true,
    },
    titleText: {
        type: String,
        default: null,
    },
    grayscale: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'default',
    },
})

const { grayscale, title, size } = toRefs(props)

const classPriceInPharmacy = [
    grayscale.value && 'price-in-pharmacy--grayscale',
    title.value && 'price-in-pharmacy--detail',
    size.value && `price-in-pharmacy--${size.value}`,
]

const openModalPriceInPharmacy = () => {
    useNuxtApp().$bus.$emit('showModal', 'price-in-pharmacy-modal')
}
</script>

<style lang="scss" scoped>
.price-in-pharmacy {
    display: inline-block;
    border-radius: 5px;
    overflow: hidden;
    margin: 0 auto;
    min-width: 125px;

    @media (max-width: 768px) {
        margin: 0.25rem auto;
        min-width: 100px;
    }

    &--detail {
        @media (min-width: 480px) {
            margin-bottom: 0.75rem;
            margin-top: 0.3rem;
        }
    }

    &--grayscale {
        .price-in-pharmacy__title {
            background: #e1e1e1;
        }

        .price-in-pharmacy__content {
            background: #f6f6f6;
            color: #333333;
        }
    }

    &--xl {
        .price-in-pharmacy__title {
            font-size: 14px;
            padding: 0.5rem 1rem;

            @media (max-width: 768px) {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 49px;
                padding: 0;
            }
        }
        .price-in-pharmacy__new {
            font-size: 24px;
            padding: 1rem;
            @media (min-width: 768px) {
                min-width: 250px;
            }
        }
    }
}

.price-in-pharmacy__title {
    background-color: $color-green-light;
    color: $color-dark;
    font-weight: 700;
    font-size: 12px;
    padding: 0.25rem 0.5rem;
    text-align: center;
}

.price-in-pharmacy__content {
    background-color: $color-green-dark;
    color: $color-white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        width: 100%;
    }

    &--default {
        @media (min-width: 768px) {
            display: block;
            text-align: center;
        }
    }
}

.price-in-pharmacy__old {
    padding-left: 0.5rem;
    font-weight: normal;

    @media (min-width: 768px) {
        padding: 0 0.5rem;
    }

    &--catalog {
        padding-right: 0;
    }
}

.price-in-pharmacy__new {
    font-weight: bold;
    padding: 0.25rem 0.5rem;
    font-size: 16px;
    margin: 0 auto;

    .ico {
        margin-left: 0.5rem;

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
